module.exports = __webpack_public_path__ + "img/Redem Icon.1006649d.png";